var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivitiesActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62224 10.7159L12.9065 7.30526L13.0119 7.22177C13.4449 6.87891 13.518 6.24998 13.1751 5.817C13.1276 5.75705 13.0735 5.70274 13.0136 5.65514L8.62229 2.16266C8.25791 1.87286 7.74175 1.87286 7.37738 2.16266L2.98305 5.65753C2.5508 6.00131 2.47908 6.6304 2.82285 7.06264C2.86983 7.12172 2.92335 7.17528 2.98238 7.22231L3.0865 7.30526L7.3771 10.7163C7.74162 11.0061 8.25791 11.0059 8.62224 10.7159Z",
    fill: "#0078D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37124 12.4469L3.55762 9.41506C3.29736 9.20815 2.91864 9.2514 2.71173 9.51166C2.71014 9.51366 2.70856 9.51567 2.707 9.5177C2.50205 9.78235 2.55044 10.163 2.8151 10.368C2.81606 10.3687 2.81702 10.3695 2.81798 10.3702L7.39185 13.8685C7.75038 14.1428 8.24817 14.1428 8.60675 13.8686L13.1789 10.373C13.4465 10.1683 13.4976 9.78541 13.293 9.51771C13.2921 9.51657 13.2912 9.51543 13.2903 9.51429C13.0848 9.24937 12.7034 9.20123 12.4385 9.40677C12.4366 9.40826 12.4347 9.40976 12.4327 9.41128L8.616 12.4468C8.25168 12.7365 7.73561 12.7366 7.37124 12.4469Z",
    fill: "#0078D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesActive);
export default __webpack_public_path__ + "static/media/activities_active.5d0d6035.svg";
export { ForwardRef as ReactComponent };